const dealsDOTD = function () {
	const accordions = new getAccordions4i();
	const helpers = new formHelpers4i();
	const countdown = new countdownDOTD();

	let buyBtn, dotdSlider;

	const init = async () => {
		await update();
	},
		update = async () => {
			// TODO add cache logic here

			let url = '/dealoftheday/deals/dealinfo';
			const dealId = parseDealID();

			// Check if the link is from an old or expired deal, and if so, include in the request to the server		
			if (dealId.length > 0) url = url + "/" + dealId;

			try {
				const response = await fetch(url, {
					method: 'POST',
					body: JSON.stringify({ dealId }),
					headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch' }
				})
					.then(response => response.json())
					.then(response => {

						var result;

						if (response.list) result = JSON.parse(response.list);

						if (response.success) renderDeal(result);
						else {
							console.log(response.message);
							showOffline();
						}
					});
			} catch (error) {
				console.log(error);
				showOffline();
			}
		},
		setUpSlider = () => {
			dotdSlider = new tns({
				container: document.getElementById('dotd-slider'),
				rewind: true,
				lazyload: true,
				prevButton: document.getElementById('leftArrowClick'),
				nextButton: document.getElementById('rightArrowClick'),
				speed: 500,
				items: 1, // number items on mobile
				nav: true,
				navPosition: "bottom"
			});
		},
		showOffline = () => {
			helpers.RemoveLoadingOverlay();
			const noDealTemplate = document.getElementById('offlineTemplate').innerHTML; // All HTML currently, no need to render via mustache
			document.getElementById('ProductDetails').innerHTML = noDealTemplate;
		},
		showNoDealToday = () => {
			var noDealTemplate = document.getElementById('noDealTemplate').innerHTML; // All HTML currently, no need to render via mustache
			document.getElementById('ProductDetails').innerHTML = noDealTemplate;
		},
		parseDealID = () => {
			var entireQS = location.search;
			if (entireQS.indexOf('?') >= 0 && entireQS.indexOf('deal=') > 0) {
				var qs = entireQS.substring(entireQS.indexOf('?') + 1).split('&'); // break apart all QS entries
				for (var i = 0; i < qs.length; i++) {
					if (qs[i].indexOf('deal=') >= 0) {
						var dealId = qs[i].substring(qs[i].indexOf('deal=') + 5);
						if (dealId.length > 0) {
							return dealId;
						}
					}
				}
			}
			return '';
		},
		adjustAccordions = () => {
			const optInOpen = document.getElementById("optInSection").getAttribute("aria-hidden") == "false";
			// open all on tablet / desktop
			if (window.innerWidth >= 600 && !optInOpen) accordions.openAll(document.getElementById("bottomInfo"));
			else if (window.innerWidth < 600 && optInOpen) accordions.closeAll(document.getElementById("bottomInfo"));
		}
	addExtraImagesToScroller = (currentDeal) => {
		let extraImagesHTML = "";
		for (let i = 0; i < currentDeal.ExtraImages.length; i++) {
			extraImagesHTML += `
				<div class="scrollerItem">
    					<img class="responsiveImg tns-lazy-img" src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" loading="lazy" data-src="${currentDeal.ExtraImages[i]}" alt="Alternate view of ${currentDeal.ProductName}" />
				</div>`;
		}
		// add extra images to HTML
		document.getElementById('ProductDetails').querySelector(".scrollerItem").insertAdjacentHTML("afterend", extraImagesHTML);
	},
		renderDeal = (dealModel) => {
			// Get the current deal
			if (dealModel.length < 1) {
				// There was a valid response, but no deal info was returned. Load the "no deal" view.
				showNoDealToday();
				return;
			}

			var currentDeal = dealModel[0];
			var dealId = parseDealID();
			if (dealModel.length > 1) {
				if (dealId.length > 0) {
					// select the specified deal in the QS. If the Deal ID is not found, leave it using the first one.
					for (var i = 0; i < dealModel.length; i++) {
						if (dealModel[i].DealID === dealId) currentDeal = dealModel[i];
					}
				} else {
					// no deal id specified, select the current deal
					for (var i = 0; i < dealModel.length; i++) {
						if (dealModel[i].CurrentDeal === true) currentDeal = dealModel[i];
					}
				}
			}

			// bind to the mustache templates here
			var dealTemplate = document.getElementById('currentDealTemplate').innerHTML;
			var copyTemplate = document.getElementById('currentWebCopyTemplate').innerHTML;
			var renderedDeal = Mustache.render(dealTemplate, currentDeal);
			var renderedCopy = Mustache.render(copyTemplate, currentDeal);
			document.getElementById('ProductDetails').innerHTML = renderedDeal;
			document.getElementById('ProductCopy').innerHTML = renderedCopy;

			// set up extra images - unsure how to do this in a mustache template ML
			addExtraImagesToScroller(currentDeal);

			//prod copy and artwork
			accordions.init(document.querySelector(".homepageLeftCol"));

			if (dealModel.length > 1) {
				var multipleDealTemplate = document.getElementById('multipleDealTemplate').innerHTML;
				var renderedMultipleDeals = Mustache.render(multipleDealTemplate, dealModel);
				document.querySelector('.detailsRightPanel').innerHTML = renderedMultipleDeals;

				// This change will reveal the sellout alternative in the accordion dropdown
				if (currentDeal.SoldOut && currentDeal.AltAvailable) {
					document.getElementById("deal" + currentDeal.DealID + "SectionDisplay").style.display = "none";
					document.getElementById("deal" + currentDeal.DealID + "AltSectionDisplay").style.display = "block";
				}

				// wire up the countdown timer for all of the upcoming deals
				for (var i = 0; i < dealModel.length; i++) {
					var upcomingDealTimeLive = new Date(dealModel[i].TimeLive);
					var currentCentralTime = new Date(currentDeal.CountDownTime);

					var upcomingDealId = dealModel[i].DealID;
					var upcomingCountdownText = document.getElementById('countdownText' + upcomingDealId);

					if (currentCentralTime.toJSON() >= upcomingDealTimeLive.toJSON()) {
						if (upcomingCountdownText) upcomingCountdownText.style.display = "none"; // current deal, hide the upcoming timer
					} else {
						if (document.getElementById('dealAvailable' + upcomingDealId)) {
							document.getElementById('dealAvailable' + upcomingDealId).style.display = "none";
						}
						countdown.CountDownToTime('countdownTime' + upcomingDealId, upcomingDealTimeLive, currentCentralTime, upcomingDealId, upcomingDealId);
					}
					// The deal following the current deal should be expanded to tease the next deal and should always be in the second position.
				}
				if (document.querySelector(".detailsRightPanel")) {
					accordions.init(document.getElementById("ProductDetails"));
					var hasCurrentDeal = document.getElementById("deal" + currentDeal.DealID + "Section") ? true : false;
					if (hasCurrentDeal) {
						var hasAccordionAfter = document.getElementById("deal" + currentDeal.DealID + "Section").nextElementSibling.nextElementSibling ? true : false;
						if (hasAccordionAfter) {
							var secondAccordion = document.getElementById("deal" + currentDeal.DealID + "Section").nextElementSibling.nextElementSibling;
							accordions.open(secondAccordion);
						} else {
							accordions.open(document.getElementById("deal" + currentDeal.DealID + "Section"));
						}
					} else {
						accordions.open(document.querySelector(".detailsRightPanel").querySelector(".accordionPanel")[0]);
					}
				}
			}
			setUpSlider();

			var dealTimeLive = new Date(currentDeal.TimeLive);
			var currentTime = new Date(currentDeal.CountDownTime);

			if (currentTime < dealTimeLive) {
				document.getElementById('countdownText').classList.remove('hide');
				document.getElementById('countdownText').style.display = "block";
				countdown.CountDownToTime('countdownTime0', dealTimeLive, currentTime, 0, currentDeal.DealID);
			}

			if (!currentDeal.SoldOut && currentTime >= dealTimeLive) {
				document.getElementById('numLeft').classList.remove('hide');
				countdown.QuantityLeft('quantityLeft', document.getElementById('hfDealID').value);
			}

			if (document.getElementById("socialLinksHolder")) {
				// Reveal social links
				var rssLink = document.getElementById('socialLinksHolder').innerHTML;
				document.getElementById('socialLinksHolder').classList.add('hide');
				document.querySelector('.socialNetworking').insertAdjacentHTML("afterbegin", rssLink);
			}

			buyBtn = document.getElementById("buyNow");
			if (buyBtn) buyBtn.addEventListener("click", purchaseDeal);

			adjustAccordions();
			window.addEventListener("resize", adjustAccordions);
		},
		purchaseDeal = (e) => {
			e.preventDefault();
			helpers.ClearStatus();
			helpers.ShowBusyBtn(buyBtn);
			buyBtn.setAttribute("disabled", "disabled");
			const dataToSend = {
				dealId: document.getElementById("hfDealID").value
			};

			fetch("/dealoftheday/sop/order/BuyItNow", {
				method: 'POST',
				headers: { 'Content-Type': 'application/json', 'RequestVerificationToken': helpers.HeaderToken, 'X-Requested-With': 'fetch' },
				body: JSON.stringify(dataToSend)
			}).then(function (response) {
				return response.json();
			}).then(function (data) {
				window.location.replace(data.url);
			});
		};
	return {
		Init: init,
		Update: update,
		SetUpSlider: setUpSlider
	};
};

(async function () {
	const deals = new dealsDOTD();
	await deals.Init();
})();